"use client";

import { useSyncExternalStore } from "react";

/**
 * Whether the visitor has said social embeds may load, for this tab session.
 *
 * An Instagram feed or a LinkedIn post sets the platform's own cookies the moment it
 * mounts, and this site asks before it sets any, so those embeds wait for a click. One yes
 * covers every feed in the work section until the tab closes, rather than a button on every
 * frame. Client websites are never framed: they are screenshots that link out.
 */
const KEY = "jrats:previews";
const listeners = new Set<() => void>();

const read = (): boolean => {
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
};

let allowed: boolean | null = null;

export const allowPreviews = () => {
  allowed = true;
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    /* Private mode: the yes lasts until reload instead. */
  }
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const usePreviewsAllowed = () =>
  useSyncExternalStore(
    subscribe,
    () => (allowed ??= read()),
    () => false,
  );
